import React, { useState } from "react";
import "./HomePage.scss";
import { useNavigate } from "react-router-dom";
import ReactModal from "react-modal";
import TermsModal from "../../../components/auth/components/TermsModal";
import PrivacyModal from "../../../components/auth/components/PrivacyModal";
import { isAutoServicesTenant } from "../../../utils/tenantBranding";

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "450px",
  },
};
const Footer = () => {
  const [isShowTermsModal, setShowTermsModal] = useState(false);
  const [isShowPrivacyModal, setShowPrivacyModal] = useState(false);


  const navigate = useNavigate();

  const navigatehandler = () => {
    navigate("/customer/about-us");
  };


  const openTermsModal = () => {
    setShowTermsModal(true);
  };

  const closeTermsModal = () => {
    setShowTermsModal(false);
  };



  const openPrivacyModal = () => {
    setShowPrivacyModal(true);
  };

  const closePrivacyModal = () => {
    setShowPrivacyModal(false);
  };
  const fetchingTenant = window.location.hostname.split(".")[0];
  const autoServicesBranding = isAutoServicesTenant(fetchingTenant);

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          {/* Logo and tagline section */}
          <div className="footer__brand">
            <div className="footer__logo-container">

               {autoServicesBranding ? (
          <img src="https://botgobucket.s3.ap-south-1.amazonaws.com/AutoServices/Logo+1.svg" alt="Auto Services logo" style={{ width: "300px" ,height:"100px"}} />
        ) : (
              <img src="https://botgobucket.s3.ap-south-1.amazonaws.com/euroraper/Car+Service.png" alt="" style={{ width: "230px", height: "52px" }} />
            
        )}
              </div>
            <p className="footer__tagline">
              SERVICING, MAINTENANCE & REPAIRS FOR ALL CARS
            </p>

          </div>

          {/* Navigation links */}
          <div className="footer__nav">
            <div className="footer__nav-column">
              <h4 className="footer__nav-title">Company</h4>
              <ul className="footer__nav-list">
                {/* <li className="footer__nav-item">
                  <a href="#changelog" className="footer__nav-link">
                    Changelog
                  </a>
                </li>
                <li className="footer__nav-item">
                  <a href="#pricing" className="footer__nav-link">
                    Pricing
                  </a>
                </li> */}
                <li className="footer__nav-item" onClick={navigatehandler}>
                  <a href="#about" className="footer__nav-link">
                    About us
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer__nav-column">
              <h4 className="footer__nav-title">Legal</h4>
              <ul className="footer__nav-list">
                <li className="footer__nav-item">
                  <a href="#privacy" className="footer__nav-link" onClick={openPrivacyModal}>
                    Privacy Policy
                  </a>
                </li>
                <li className="footer__nav-item">
                  <a href="#terms" className="footer__nav-link" onClick={openTermsModal}>
                    Terms & Conditions
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer__nav-column">
              <h4 className="footer__nav-title">Address</h4>
              <ul className="footer__nav-list">
                <li className="footer__nav-item footer__nav-item--address footer__nav-link">
                  {autoServicesBranding 
                    ? <>Third Floor, B-67, Block B, Sector 67,<br/>
                    Noida, Uttar Pradesh 201309 </>
                    : <>
                        IndoSpace Industrial Park, (Chakan-I),<br />
                        Village Mahalunge Ingale,<br />
                        Off, Talegaon-Chakan Rd, Khed Taluka,<br />
                        Maharashtra - 410501
                      </>
                  }
                </li>

              </ul>
            </div>

            <div className="footer__nav-column footer__nav-column--app-store">
              
              {/* <h4 className="footer__nav-title">App Store</h4> */}
              <div className="footer__app-links">
                <a href="https://play.google.com/store/apps/details?id=com.globtier.ercs_app.ercs_app&hl=en" className="footer__app-link">
                  <div className="footer__app-icon footer__app-icon--google">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.61 3 21.09 3 20.5Z"
                        fill="#EA4335"
                      />
                      <path
                        d="M16.81 15.12L6.05 21.34C5.79 21.48 5.49 21.48 5.23 21.34L3.84 21.85L13.69 12L16.81 15.12Z"
                        fill="#FBBC05"
                      />
                      <path
                        d="M20.16 10.8C20.68 11.1 21 11.53 21 12S20.68 12.9 20.16 13.2L16.81 15.12L13.69 12L16.81 8.88L20.16 10.8Z"
                        fill="#4285F4"
                      />
                      <path
                        d="M16.81 8.88L13.69 12L3.84 2.15C4.25 1.93 4.75 1.93 5.16 2.15L16.81 8.88Z"
                        fill="#34A853"
                      />
                    </svg>
                  </div>
                  <div className="footer__app-text">
                    <span className="footer__app-subtitle">GET IT ON</span>
                    <span className="footer__app-title">Google Play</span>
                  </div>
                </a>
                <a href="https://apps.apple.com/in/app/eurorepar-car-service/id6752607371" className="footer__app-link">
                  <div className="footer__app-icon footer__app-icon--apple">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09 22C7.85 22.05 6.8 20.68 5.96 19.47C4.25 17 2.94 12.45 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.19 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" />
                    </svg>
                  </div>
                  <div className="footer__app-text">
                    <span className="footer__app-subtitle">
                      Download on the
                    </span>
                    <span className="footer__app-title">App Store</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <ReactModal
          isOpen={isShowTermsModal}
          onRequestClose={closeTermsModal}
          style={customModalStyles}
          contentLabel="Terms and conditions"
          shouldCloseOnOverlayClick={false}
        >
          <TermsModal closeModal={closeTermsModal} />
        </ReactModal>

        <ReactModal
          isOpen={isShowPrivacyModal}
          onRequestClose={closePrivacyModal}
          style={customModalStyles}
          contentLabel="Privacy policy"
          shouldCloseOnOverlayClick={false}
        >
          <PrivacyModal closeModal={closePrivacyModal} />
        </ReactModal>

        {/* Copyright */}
        <div className="footer__bottom">
          <p className="footer__copyright">
            © {new Date().getFullYear()}{" "}
            {autoServicesBranding ? "AUTO SERVICES" : "EUROREPAR"}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


